@if (synced && !fleetId) {
  <pp-fleet-management-empty-fleet></pp-fleet-management-empty-fleet>
}
@if (synced && fleet) {
  <pp-fleet-management-fleet-page
    [ppFleetId]="fleet.id"
  ></pp-fleet-management-fleet-page>
}
